/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Validation_EmailInputs */

const fr_person_validation_email = /** @type {(inputs: Person_Validation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez une adresse e-mail complète, par exemple nom@entreprise.com.`)
};

const en_person_validation_email = /** @type {(inputs: Person_Validation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a complete email address, such as name@company.com.`)
};

/**
* | output |
* | --- |
* | "Enter a complete email address, such as name@company.com." |
*
* @param {Person_Validation_EmailInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_validation_email = /** @type {((inputs?: Person_Validation_EmailInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Validation_EmailInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_validation_email(inputs)
	return fr_person_validation_email(inputs)
});